import React, { useCallback, useState, useEffect } from "react";
import { Container, Col, Row, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Map from "../components/Map";
import { useDropzone } from "react-dropzone";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { apiUrl } from "../commons/inFormTypes";
import Loaders from "../components/Loaders";


function GarbageCollection() {
  const [snip, setSnip] = useState(false);
  const [address, setAddress] = useState("");
  const [areaId, setAreaId] = useState(0);
  const [areaText, setAreaText] = useState("");
  const [imageSize, setImageSize] = useState(0);
  const [image, setImage] = useState(null);
  const [areaList, setAreaList] = useState([]);
  const navigate = useNavigate();
  const userToken = localStorage.getItem("user_token");

  useEffect(() => {
    if (userToken == null) {
      navigate("/");
    } else {
      const axios = require("axios");
      setSnip(true);
      axios
        .post(apiUrl + "Get_ListArea", {
          AreaId: areaId,
          TokenId: userToken,
        })

        .then((res) => {
          setSnip(false);
          if (res.data.result === "true") {
            setAreaList(res.data.data)
          } else {
          }
        })
        .catch(function (error) {
          if (error.response) {
            toast.error(error.response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    }
  }, [areaId]);

  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      setImageSize(Math.round(file.size / 1024));
      const reader = new FileReader();
      reader.onabort = () => console.log("file reading was aborted");
      reader.onerror = () => console.log("file reading has failed");
      reader.onload = () => {
        if (file.size > 2000000) {
          return;
        } else {
          const img_src = reader.result;
          setImage(img_src);
        }
      };
      reader.readAsDataURL(file);
      // console.log(file)
    });

  }, []);

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  //.function for remove image
  const removeImage = () => {
    setImage(null);
    setImageSize(0);
  };


  const selectAreaHandler = (e) => {
    setAreaId(e.target.value);
    setAreaText(e.target.options[e.target.selectedIndex].text);
  }


  //function for register request
  const regRequestHandler = () => {
    if (address === "" || image === null || areaText === 0 || areaId ===0) {
      toast.error("لطفا اطلاعات مورد نظر را وارد نمایید", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return false;
    } else {
    const axios = require("axios");
    axios.post(apiUrl + "Insert_Pasmand", {
      Address: address,
      Img: image,
      Type_Area: areaText,
      Type_Area_Id: areaId,
      TokenId: userToken,
    })
      .then((res) => {
        if (res.data.result === "true") {
          toast.success(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.error(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .catch(function (error) {
        if (error.response) {
          toast.error(error.response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });
 }
  }

  return (
    <div>
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} lg={8} className="rgc-request p-4 rgc-profile ">
            <div className="d-flex rgc-title">
              <div className="rgc-title-point"></div>
              <h4>اعلام <span>جمع آوری نخاله های شهری </span></h4>
            </div>
            <Row className="justify-content-center g-3">

              <Col xs={12}>
                <label >لطفا تصویر پسماند موردنظر را در این قسمت  وارد نمایید:</label>
                {!image ? (
                  <div className="col-12 mt-2">
                    <div className="dropzone mt-0" id="myDropzone2">
                      <div {...getRootProps()} className="rgc-dropzone-icon">
                        <input {...getInputProps()} multiple={true} />
                        <button className="dz-button" type="button">
                          <i className="fas fa-plus-square"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="col-12">
                    <div
                      className="dropzone mt-0 drop-custom"
                      id="myDropzone2"
                    >
                      <div className="imgbox__container">
                        <img src={image} className="imgbox__img" alt="" />
                        <p
                          className="imgbox__size"
                          onClick={() => removeImage()}
                        >
                          {imageSize + " KB"}{" "}
                          <i className="fa fa-times-circle"></i>
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </Col>


              <Col xs={12} className="text-start me-auto">
                <Form.Group>
                  <Form.Select
                    className="rgc-select"
                    value={areaId}
                    onChange={(e) => selectAreaHandler(e)}
                  >
                    <option key={0} value="0">
                      انتخاب منطقه
                    </option>
                    {areaList.map((data, index) => (
                      <option key={index} value={data.ParaCode}>
                        {data.Title}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col xs={12}>
                <Form.Group className="mb-3 rgc-input-icons" controlId="exampleForm.ControlTextarea1">
                  <Form.Label>آدرس</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    placeholder="آدرس..."
                    className="rgc-profile-input"
                    value={address}
                    onChange={(event) => setAddress(event.target.value)
                    }
                  />
                </Form.Group>
              </Col>


              <Col xs={12} className="text-center" style={{ zIndex: "0" }}>
                {/* <Form.Label>موقعیت</Form.Label> */}
                {/* <Map /> */}
              </Col>

              <Col xs={4} className="text-center">
                <Button className="rgc-order-btn rgc-order-btn-sub" onClick={regRequestHandler}>
                <Loaders loads={snip} />
                  ثبت
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default GarbageCollection;
